<script>
  import { onDestroy, createEventDispatcher } from 'svelte';
  import GroupAjax from '@ajax/group';
  import { getGroupStore } from '@stores/group';
  let searchTermStore = getGroupStore('searchTermStore');
  let recsStore = getGroupStore('recsStore');
  import { getCurrentUserStore } from '@stores/current_user';

  const dispatch = createEventDispatcher();

  export let group;
  export let searched = false;
  export let loading = false;
  export let focus = false;
  export let searchResults = [];
  export let clearText = 'clear search';
  export let showHide = false;
  export let minimumRecs = 5;
  export let mobile = false;

  let searchTerm = '';
  let recs = [];
  let inputEl;
  let user = getCurrentUserStore('default');

  $: if (inputEl && focus) {
    inputEl.focus();
  }

  let search = async function () {
    loading = true;

    if (searchTerm != '') {
      searched = true;
      try {
        searchResults = await GroupAjax.search(group, searchTerm);
      } catch {}
    } else {
      searched = false;
    }

    loading = false;
  };

  let setSearchTerm = function () {
    searchTermStore.set({ term: inputEl.value });
  };

  let unsubRecs = recsStore.subscribe((x) => (recs = x));
  let unsub = searchTermStore.subscribe((x) => {
    searchTerm = x.term;
    search();

    if (inputEl) {
      inputEl.value = searchTerm;
    }
  });

  onDestroy(() => {
    unsub();
    unsubRecs();
  });
</script>

<style style="text/scss" lang="scss">
  .ui-search-placeholder {
    height: 48px;
    margin-bottom: 38px;
  }

  .ui-search {
    display: flex;
    border-radius: 15px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 18px;
    padding-right: 18px;
    height: 48px;
    margin-bottom: 38px;
    background: #ffffff;
    box-shadow: 0px 22px 100px rgba(0, 0, 0, 0.104103);

    .ui-search-input {
      flex: 1;
      display: flex;
      align-items: center;
      svg {
        margin-top: 3px;
        overflow: hidden;
        vertical-align: middle;
      }
      input {
        margin-left: 13px;
        margin-right: 13px;
        height: 28px;
        border: 0px;
        flex: 1;
        background: transparent;
        color: #666;
        vertical-align: middle;
        transition: all 0.2s ease-in-out;
        overflow: visible;
        margin-bottom: 0px;
        &::placeholder {
          color: #bbb;
        }
        &:focus {
          outline: none;
        }
      }
    }
  }

  @media only screen and (max-width: 1000px) {
    .ui-search:not(.mobile) {
      display: none;
    }
  }
</style>

{#if searchTerm != '' || recs.length >= minimumRecs}
  <div class:mobile={mobile} class="ui-search" style={user && user.id ? 'margin-right: 0px' : ''}>
    <form class="ui-search-input" on:submit|preventDefault|stopPropagation={setSearchTerm}>
      {#if loading}
        <i class="fa fa-spinner fa-spin" style="opacity: 0.5" />
      {:else}
        <svg
          class="ui-search-icon"
          width="23"
          height="23"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.5633 15.0633C16.9064 12.7201 16.9064 8.92112 14.5633
              6.57798C12.2201 4.23483 8.42112 4.23483 6.07798
              6.57798C3.73483 8.92112 3.73483 12.7201 6.07798
              15.0633C8.42112 17.4064 12.2201 17.4064 14.5633 15.0633Z"
            stroke="#C5C3CD"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
          <path
            d="M15.3206 15.8206L17.3206 17.8206"
            stroke="#C5C3CD"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      {/if}
      <input
        bind:this={inputEl}
        style="-webkit-appearance: none; -moz-appearance: none;
            appearance: none;"
        type="text"
        name="search"
        placeholder="Search in this list" />

      {#if searched && searchTerm != ''}
        <a
          on:click|preventDefault|stopPropagation={() => {
            searchTermStore.set({ term: '' });
            dispatch('clear');
          }}
          href="/"
          style="display: flex; align-items: center; font-size: 12px;
              color: #FF5567">
          {clearText}
        </a>
      {:else if showHide}
        <a
          on:click|preventDefault|stopPropagation={() => {
            searchTermStore.set({ term: '' });
            dispatch('hide');
          }}
          href="/"
          style="display: flex; align-items: center; font-size: 12px;
          color: #FF5567">
          hide
        </a>
      {/if}
    </form>
  </div>

  {#if loading}
    <slot name="loading" />
  {:else if searched}
    {#if searchResults && searchResults.length > 0}
      <slot name="results" searchResults={searchResults} />
    {:else}
      <slot name="empty" />
    {/if}
  {/if}
{:else}
  <div class="ui-search-placeholder" />
{/if}
